import { combineReducers } from '@reduxjs/toolkit';

import { topBike } from './core/topBike';
import { topCar } from './core/topCar';
import { topCommercial } from './core/topCommercial';
import { topDealer } from './core/topDealer';
import { topService } from './core/topService';
import { topPlacement } from './core/topPlacement';
import { topCompany } from './core/topCompany';
import { topRent } from './core/topRent';
import { topParts } from './core/topParts';

export default combineReducers({
    topCompany,
    topService,
    topPlacement,
    topDealer,
    topCar,
    topBike,
    topCommercial,
    topRent,
    topParts,
});
